export { default } from './getHighlight'
